import Grid from "@mui/material/Grid2";
import { HtmlHelpers } from "../../../shared/constants/all-constant";
import GridIndex from "../../../shared/ReusableComponents/GridIndex";
import { DateFormatter } from "../../../shared/utils/DateFormatter";

const PatientCard = (props: any) => {
  const data = props.data;
  return (
    <Grid container spacing={0} className="box-grid">
      <Grid sx={{ position: "relative" }}>
        {data.image && (
          <div
            data-testid="image-bg"
            className="img-bg"
            style={{
              backgroundImage: `url('data:image/png;base64,${data.image.trim()}')`,
            }}
          ></div>
        )}
        {!data.image && (
          <div
            className="defaultProfile fixWidth"
            data-testid="default-profile"
          ></div>
        )}
      </Grid>
      <Grid size={"grow"} sx={{ marginLeft: "15px" }}>
        <GridIndex field="MRN" value={data.mrn} />
        <GridIndex
          field="Full Name"
          value={`${data.patientFirstName} ${
            data.patientMiddleName ? data.patientMiddleName + " " : ""
          }
        ${data.patientLastName}`}
        />
        <GridIndex field="D.O.B." value={DateFormatter.formatDate(data.dob)} />
        <GridIndex field="Age" value={DateFormatter.calculateAge(data.dob)} />
        <GridIndex field="Sex" value={data.gender} />
        <GridIndex
          field="Doctor's Name"
          value={`${"Dr."}${HtmlHelpers.SINGLE_SPACE}${data.doctorName}`}
        />
        <GridIndex field="Ethnicity" value={data.ethinicity} />
        <GridIndex
          field="Interpreter Required"
          value={data.isInterpreterRequired ? "Yes" : "No"}
          fieldSize={7}
          valueSize={1}
        />
        <GridIndex
          field="Aboriginal and Torres Strait Islander"
          value={data.isATSI ? "Yes" : "No"}
          fieldSize={7}
          valueSize={1}
        />
      </Grid>

      <Grid size={"grow"}>
        <strong>
          <div style={{ marginBottom: "6px", fontSize: "1.25rem" }}>Alerts</div>
        </strong>
        <GridIndex
          fieldSize={2.5}
          valueSize={9}
          field="MRSA"
          value={data.isMRSA ? "Positive" : "Negative"}
        />
        <div className="alert-space">
          <GridIndex
            fieldSize={2.5}
            valueSize={9}
            field="Allergies"
            value={
              <div
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {data.allergies}
              </div>
            }
            isScrollable={true}
          />
        </div>
        <div className="alert-space">
          <GridIndex
            fieldSize={2.5}
            valueSize={9}
            field="Remarks"
            value={
              <div
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {data.remarks}
              </div>
            }
            isScrollable={true}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default PatientCard;
